/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbdf41a5ea2d18db8f545a9f4aed5b11>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "EmojiCasual".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing a casual or relaxed tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const EmojiCasualIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M11.25 10.25S10 12 8 12s-3.25-1.75-3.25-1.75m-3.233-5.5a7.25 7.25 0 1 0 12.965 0m-12.965 0A7.25 7.25 0 0 1 8 .75a7.25 7.25 0 0 1 6.483 4m-12.966 0h.733m12.233 0h-.733m-4.875 0 .196 1.825a1.875 1.875 0 0 0 1.864 1.675h1.054a1.25 1.25 0 0 0 1.223-.988l.538-2.512m-4.875 0h4.875m-4.875 0h-1.75m0 0-.196 1.825A1.875 1.875 0 0 1 5.065 8.25H4.011a1.25 1.25 0 0 1-1.223-.988L2.25 4.75m4.875 0H2.25"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
EmojiCasualIcon.displayName = 'EmojiCasualIcon';
var _default = exports.default = EmojiCasualIcon;